export default "__VITE_ASSET__zNhINpNl__"